import { BASE_PORTION, type Portion } from '../types'

/** Ürünün bütün porsiyonları: önce kendi fiyatı (1 porsiyon), sonra eklenenler. */
export function portionsOf(product: {
  priceKurus: number
  portions?: Portion[] | null
}): (Portion & { base?: true })[] {
  return [{ name: BASE_PORTION, priceKurus: product.priceKurus, base: true }, ...(product.portions ?? [])]
}
